export * from 'server/models/AddVesselRequest';


// WEBPACK FOOTER //
// ./data/models/AddVesselRequest.ts